import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../validation/register.validation';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../services/user.service';
import { matchOtherValidator } from  '../validation/password.validation';
import { Router } from '@angular/router';



@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

  private user;
  public editMode: boolean = false;
  public pwChangeMode = false;
  public pwChangeForm

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { 
    this.user = JSON.parse(localStorage.getItem("user"));
    this.setFormPwControl();
  }

  ngOnInit() {
    /* 
      localStorage.setItem('user',JSON.stringify(user));
      JSON.parse(localStorage.getItem("user"));
    */
  }

    //UPDATE USER
    enableEditMode(){
      this.editMode = true;
    }
  
    resetUser(){
      this.editMode = false;
      this.user = JSON.parse(localStorage.getItem("user"));
      console.log("reset User called")
    }
  
    saveUserUpadte(){
      console.log("save User called")
      this.userService.updateUser(this.user.first_name,this.user.last_name)
      .then((res)=>{
        let user = JSON.parse(localStorage.getItem("user"));
        user.first_name = this.user.first_name;
        user.last_name = this.user.last_name;
        //return this.storage.set("user",user);
      })
      .then((res)=>{
        this.editMode = false;
        console.log("User updated: ", res);
      })
    }
  
    // UPDATE PASSWORD
  
    enablePwChangeMode(){
      this.pwChangeMode = true;
    }
  
    disablePwChangeMode(){
      this.pwChangeMode = false;
    }
  
    setFormPwControl(){
      this.pwChangeForm = this.formBuilder.group({
        password: [ '' , Validators.compose( [ Validators.required,ValidationService.passwordValidator])], 
        newPassword: [ '' , Validators.compose( [ Validators.required,ValidationService.passwordValidator])],       
        pwdConfirm: [ '',[
          Validators.required,
          matchOtherValidator('newPassword')
        ]],
      })
    }
  
  
    // Logout from Session and delete Local Data
    logout() {
      console.log("try to logout");
      let user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        let token = user.session_token
        this.userService.logout(token).then(() => {
          localStorage.removeItem('user');
          this.router.navigate(['login-page']);
  
        }, (err) => {
          console.log(err)
          localStorage.removeItem('user');
          this.router.navigate(['login-page']);
        });
      } else {
        console.log('no User found')
        localStorage.removeItem('user');
        this.router.navigate(['login-page']);
  
      }
    }
  
    updatePassword(){
      this.userService.updatePassword(this.pwChangeForm.get('password').value, this.pwChangeForm.get('newPassword').value)
      .then((res)=>{
        console.log(res);
        //this.toastCtrl.create({message: "Ihr Passwort wurde erfolgreich geändert!", duration: 3000, position: 'bottom'}).present()
        this.logout();
      }).catch((error)=>{
        //this.toastCtrl.create({message: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut", duration: 3000, position: 'bottom'}).present()
        console.log(error)
      })
    }
  
    setUserInactive(){
      let user = JSON.parse(localStorage.getItem("user"));
        if(user){
          this.userService.setUserInactive(user.session_token, user.id).then((res)=>{
            this.logout();
            console.log(res);
          })
        }
    }

  
    /* TODO: implement confirm
    presentDeleteConfirm() {
      let alert = this.alertCtrl.create({
        title: 'Account wirklich löschen?',
        message: 'Wollen Sie Ihren Account wirklich löschen? Alle bereits gekauften Pakete und Videos und gehen dabei verloren.',
        buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
          console.log('Cancel clicked');
          }
        },
        {
          text: 'LÖSCHEN',
          handler: () => {
            this.setUserInactive();
          }
        },			
        ]
      });
  
      alert.present();
    }
    */
}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts